import LifeEventChoice from '../widgets/lifeEventsScreens/LifeEventChoice';
import LifeEventCongratulations from '../widgets/lifeEventsScreens/LifeEventCongratulations';
import { useEffect, useState } from 'react';
import { EnrollmentProvider } from '../../providers/enrollment';
import { LifeEventsProvider } from '../../providers/life-events';

const eventData = [
  {
    id: '1',
    title: "You're eligible to add your new child to coverage.",
    imagePath: 'baby.png',
  },
  {
    id: '2',
    title: "You're eligible to add your new child to coverage.",
    imagePath: 'baby.png',
  },
  {
    id: '3',
    title: "You're eligible to add your new child to coverage.",
    imagePath: 'baby.png',
  },
  {
    id: '4',
    title: "You're eligible to add your new child to coverage.",
    imagePath: 'baby.png',
  },
  {
    id: '5',
    title: "You're eligible to add your new child to coverage.",
    imagePath: 'baby.png',
  },
];

const LifeEventsView = () => {
  const [value, setValue] = useState('');
  const [isSelectionValid, setValid] = useState(false);
  const [eventDataValue, setEventDataValue] = useState({
    id: '',
    title: '',
    imagePath: '',
  });

  const handleLifeEventChoice = (e: any) => {
    setValue(e);
  };

  const handleIsSelectionValid = () => {
    setValid((prev) => (value ? (prev = true) : (prev = false)));
  };

  useEffect(() => {
    eventData.filter((data) => {
      if (data.id === value) setEventDataValue(data);

      return data;
    });
  }, [value]);

  return !isSelectionValid ? (
    <LifeEventChoice
      selectValue={value}
      onChange={handleLifeEventChoice}
      onClick={handleIsSelectionValid}
    />
  ) : (
    <LifeEventCongratulations data={eventDataValue} />
  );
};

const LifeEvents = () => {
  return (
    <EnrollmentProvider>
      <LifeEventsProvider>
        <LifeEventsView />
      </LifeEventsProvider>
    </EnrollmentProvider>
  );
};

export default LifeEvents;
